var map = {
	"./portrait4.jpg": 8129,
	"./portrait5.jpg": 6298,
	"./portrait6.jpg": 775,
	"./portrait66.jpg": 902,
	"./portrait77.jpg": 1334,
	"./portrait88.jpg": 5341,
	"assets/photo/portraits/portrait4.jpg": 8129,
	"assets/photo/portraits/portrait5.jpg": 6298,
	"assets/photo/portraits/portrait6.jpg": 775,
	"assets/photo/portraits/portrait66.jpg": 902,
	"assets/photo/portraits/portrait77.jpg": 1334,
	"assets/photo/portraits/portrait88.jpg": 5341
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3927;